import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-clients-page',
  templateUrl: './clients-page.component.html',
  styleUrls: ['./clients-page.component.css']
})
export class ClientsPageComponent implements OnInit {
  public caseStudies = [
    {
      company: "The AZ Way Handymen",
      paragraph1: "Alexa and Zack reached out to secure their domain and to create a new website in preparation to take the next steps in their business! They we're wanting a simple website that can have features added as their needs change, we setup their site with a contact form for both customers and contractors to reach out. We also incorporated CompanyCam as a way to allow them to upload projects onto their website without having to get a full authentication and editing system.",
      paragraph2: "Now that the foundation has been set up, our next push will be towards increasing the content on the site, adding dynamic reviews, and incorporating some additional marketing elements into the site to help transition away from CompanyCam and increase the direct contact with their customers.",
      image: "assets/img/theazwayhandymen_thumb.jpg"
    },
    {
      company: "Epic Photobooth",
      paragraph1: "Initially the owner did not have the intention of creating a side business, but after a very successful first event where a few attendees inquiried into the machine he got motivated and reached out to get a website created and completed in two weeks with scheduling capabilities, just in time for the machine's next event.",
      paragraph2: "From past experience, we knew of a free scheduling plugin that allowed us to save time and provide an additional global language selector feature to help him provide features that would benefit his target audience. Our next steps is to incorporate a contact form on the website to allow Epic Photobooth to take inquiries directly from the page.",
      image: "assets/img/epicphotobooth_thumb.jpg"
    }
  ]
  constructor() { }

  ngOnInit(): void {
  }

}
